import {createAsyncThunk} from "@reduxjs/toolkit";
import {client} from "../../_api/client";
import {AUTH} from "./authService";

export const getCourses = createAsyncThunk(
    `${AUTH}/getCourses`,
    async () => {
        const response = await client.get("/course/all");
        return response.data;
    }
)

export const saveTeacher = createAsyncThunk(
    `${AUTH}/saveTeacher`,
    async (body) => {
        const response = await client.post("/user/teacher", body);
        return response.data;
    }
)

export const getTeachers = createAsyncThunk(
    `${AUTH}/getTeachers`,
    async () => {
        const response = await client.get("/user/all/ROLE_TEACHER");
        return response.data;
    }
)

export const getStudents = createAsyncThunk(
    `${AUTH}/getStudents`,
    async () => {
        const response = await client.get("/user/all/ROLE_STUDENT");
        return response.data;
    }
)

export const changeBalance = createAsyncThunk(
    `${AUTH}/changeBalance`,
    async (body) => {
        const response = await client.post("/student/changeBalance", body);
        return response.data;
    }
)

export const removeTeacher = createAsyncThunk(
    `${AUTH}/removeTeacher`,
    async (id) => {
        const response = await client.delete(`/teacher/delete/cascade/${id}`);
        return response.data;
    }
)

// STATISTIC

export const getCountOfUnique = createAsyncThunk(
    `${AUTH}/getCountOfUnique`,
    async (count) => {
        const response = await client.get(`/statistic/getCountOfUnique/${count}`,);
        return response.data;
    }
)

export const getCountOfUniqueHost = createAsyncThunk(
    `${AUTH}/getCountOfUniqueHost`,
    async (count) => {
        const response = await client.get(`/statistic/getCountOfUniqueHost/${count}`);
        return response.data;
    }
)

